import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ICustomer } from '../../core/interfaces/ICustomer';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { SwitchComponent } from '../../../../shared/components/switch/switch.component';
import { FormsModule } from '@angular/forms';
import { INewsletterSubscription } from '../../core/interfaces/INewsletterSubscription';
import { CustomersService } from '../../core/services/CustomersService';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { finalize } from 'rxjs';
import { NewsletterStatues } from '../../core/enums/NewsletterStatues';

@Component({
  selector: 'app-newsletter-table',
  standalone: true,
  imports: [
    TranslatePipe,
    SwitchComponent,
    FormsModule
  ],
  templateUrl: './newsletter-table.component.html',
  styleUrl: './newsletter-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterTableComponent extends BaseComponent {

  @Input({ required: true }) customer: ICustomer;

  private readonly _customersService = inject(CustomersService);

  public toggleSubscription(s: INewsletterSubscription): void {
    if (s.isActive) {
      this._customersService.subscribeToNewsletter(s.cinemaId, this.customer.id)
        .pipe(
          finalize(() => this.cdr.detectChanges())
        )
        .subscribe({
          next: () => {
            s.status = NewsletterStatues.ACTIVE;

            this.notificationService.pushSuccess(
              'Erfolg'.trans('notifications/success.Title'),
              'Subscribed successfully.'.trans('customers/customer-details-modal/newsletter/notifications/subscribe-success.Message')
            );
          },
          error: ({ error }: ApiErrorResponse) => {
            s.isActive = false;

            this.notificationService.pushError(
              'Fehler'.trans('notifications/error.Title'),
              error.message.trans(`subscribe-to-newsletter/notifications/${error.message}.Message`)
            );
          }
        });
    } else {
      this._customersService.unsubscribeFromNewsletter(s.cinemaId, this.customer.id)
        .pipe(
          finalize(() => this.cdr.detectChanges())
        )
        .subscribe({
          next: () => {
            s.status = NewsletterStatues.NOT_EXIST;

            this.notificationService.pushSuccess(
              'Erfolg'.trans('notifications/success.Title'),
              'Unsubscribed successfully.'.trans('customers/customer-details-modal/newsletter/notifications/unsubscribe-success.Message')
            );
          },
          error: ({ error }: ApiErrorResponse) => {
            s.isActive = true;

            this.notificationService.pushError(
              'Fehler'.trans('notifications/error.Title'),
              error.message.trans(`unsubscribe-from-newsletter/notifications/${error.message}.Message`)
            );
          }
        });
    }
  }
}
